import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isFunction } from '../helper';
const AccordionGroup = _ref => {
  let {
    children
  } = _ref;
  const [index, setIndex] = useState(-1);
  return (
    /*#__PURE__*/
    /*
     * Don't remove this fragment. This is necessary for the documentation script to generate a section about this component.
     * It's a bug in react-docgen. Related issues: https://github.com/reactjs/react-docgen/issues/336
     */
    React.createElement(React.Fragment, null, React.Children.map(children, (child, childIndex) => /*#__PURE__*/React.cloneElement(child, {
      open: childIndex === index,
      onChange: event => {
        if (childIndex === index) {
          setIndex(-1);
        } else {
          setIndex(childIndex);
        }
        isFunction(child.props.onChange) && child.props.onChange(event, index);
      }
    })))
  );
};
AccordionGroup.displayName = 'AccordionGroup';
AccordionGroup.defaultProps = {
  children: null
};
process.env.NODE_ENV !== "production" ? AccordionGroup.propTypes = {
  /**
   * Sets the children.
   */
  children: PropTypes.node
} : void 0;
export default AccordionGroup;